import defaultTheme from './defaultTheme';
const eBayCBTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0070ba', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0070ba', background: '#0070ba' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0070ba' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0070ba', border: '#0070ba', background: '#0070ba' }), field: {
        focus: '#0070ba',
        label: '#0070ba',
        icon: '#0070ba',
    } });
export default eBayCBTheme;
